import React, { useState } from 'react';

import { UnControlled as CodeMirror } from "react-codemirror2";
import "./codemirror.scss";
// import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/jinja2/jinja2';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/python/python'; // For Jinja2 Python parts
// import 'codemirror/theme/material.css'; 

const CodeMirrorEditor = ({instance, codeMirrorData, setCodeMirrorData, initialValue}) => {
    // Seeded once: feeding every keystroke back in as `value` would reset the
    // cursor. Remount with a new key to load different content.
    const [seed] = useState(initialValue);

    return (
        <CodeMirror
            style={{ padding: 20 }}
            // value={codeMirrorData}
            value={seed}
            editorDidMount={(editor) => {
                instance = editor;
            }}
            options={{
                mode: "htmlmixed",
                theme: "material",
                lineNumbers: true,
                autoRefresh: true,
            }}
            onChange={(editor, data, value) => {
                // setCodeMirrorLatestData(value);
                setCodeMirrorData(value)
            }}
        />
    );
}

export default CodeMirrorEditor;